import React, { useEffect } from "react";
import { logoutHandler } from "../../utils/loginHandler";
import { useNavigate } from "react-router-dom";
import { openNotification } from "../../utils/UI/openNotification";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    logoutHandler();
    openNotification("success", {
      message: "Logged out successfully.",
    });
    navigate("/login");
  }, []);
  return null;
}
